// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Loyv","tooltip":"_25PXr","topLeft":"gHgel"};